// src/pages/MyGroupsPage.jsx
import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, RefreshCw, Users, ArrowLeft } from 'lucide-react';
import { groupsAPI } from '../api/groupsApi';
import GroupCard from '../components/Groups/GroupCard';
import './GroupsPage.css';

const MyGroupsPage = () => {
  const navigate = useNavigate();
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);
  const [roleFilter, setRoleFilter] = useState('all');

  const fetch = useCallback(async () => {
    setLoading(true);
    try {
      const data = await groupsAPI.getMyGroups();
      setGroups(Array.isArray(data) ? data : data.results ?? []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetch(); }, [fetch]);

  const filtered =
    roleFilter === 'all'
      ? groups
      : groups.filter((g) => g.user_role === roleFilter);

  const roleCounts = groups.reduce((acc, g) => {
    acc[g.user_role] = (acc[g.user_role] || 0) + 1;
    return acc;
  }, {});

  return (
    <div className="groups-page">
      <div className="groups-page__header">
        <div className="groups-page__header-left">
          <button className="btn btn--ghost btn--sm" onClick={() => navigate('/groups')}>
            <ArrowLeft size={15} /> Back
          </button>
          <div>
            <h1 className="groups-page__title">My Groups</h1>
            <p className="groups-page__subtitle">
              {groups.length} group{groups.length !== 1 ? 's' : ''} you belong to
            </p>
          </div>
        </div>
        <button
          className="btn btn--primary"
          onClick={() => navigate('/groups/create')}
        >
          <Plus size={16} /> Create New
        </button>
      </div>

      {/* Role filter tabs */}
      <div className="filter-tabs">
        {['all', 'owner', 'admin', 'editor', 'viewer'].map((r) => {
          const count = r === 'all' ? groups.length : (roleCounts[r] || 0);
          if (r !== 'all' && count === 0) return null;
          return (
            <button
              key={r}
              className={`filter-tab ${roleFilter === r ? 'filter-tab--active' : ''}`}
              onClick={() => setRoleFilter(r)}
            >
              {r === 'all' ? 'All' : r.charAt(0).toUpperCase() + r.slice(1)}
              <span className="filter-tab__count">{count}</span>
            </button>
          );
        })}
      </div>

      {loading ? (
        <div className="groups-page__loading">
          <RefreshCw size={24} className="spinning" />
        </div>
      ) : filtered.length === 0 ? (
        <div className="groups-page__empty">
          <Users size={40} />
          <p>No groups found.</p>
          <button className="btn btn--primary" onClick={() => navigate('/groups/create')}>
            <Plus size={14} /> Create a group
          </button>
        </div>
      ) : (
        <div className="groups-page__grid">
          {filtered.map((group) => (
            <GroupCard
              key={group.id}
              group={group}
              onClick={() => navigate(`/groups/${group.id}`)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default MyGroupsPage;
